import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="font-heading text-lg font-semibold text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                文爱社区
              </Link>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                专注于文字情感表达与互动的高品质社区平台，汇聚热爱文字交流的用户，在字里行间寻找温暖与共鸣。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">
                <a href="#footer-categories" className="hover:text-primary-500 transition-colors duration-200">内容分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">
                <a href="#footer-links" className="hover:text-primary-500 transition-colors duration-200">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/category/qinggan-duben" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">分类浏览</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">
                <a href="#footer-contact" className="hover:text-primary-500 transition-colors duration-200">联系我们</a>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-500">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                  <span>contact@wenaishequ.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
                  <span>文爱社区官方</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 文爱社区 - 文字情感交流平台. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap" rel="nofollow">社区规范</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}